import { render, staticRenderFns } from "./TableWrapperBody.vue?vue&type=template&id=21ccacc7&scoped=true&"
import script from "./TableWrapperBody.vue?vue&type=script&lang=js&"
export * from "./TableWrapperBody.vue?vue&type=script&lang=js&"
import style0 from "./TableWrapperBody.vue?vue&type=style&index=0&id=21ccacc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ccacc7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
